// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7e1349bf","703":"193cc0fa","787":"8d97808c"}[chunkId] + ".chunk.js";
};